export const ActionTypes = {
    SET_DATA: "app/redux/mgt-permission/SET_DATA",
    ADD: "app/redux/mgt-permission/ADD",
    REMOVE: "app/redux/mgt-permission/REMOVE",
}